// @DO - Todo: move to module and import - wasn't working initially for some reason

// Keyboard navigation for header nav 
function headerKeyboardNav(menuIndex, event) {
  const activator = event.target;

  // up & left arrows in main nav
  if (event.keyCode == '38' || event.keyCode == '37') {
    event.preventDefault();
    var tabTarget = focusToTabItem(event.target, 'prev');
    tabTarget.focus();
  }

  // down & right arrows in main nav
  if (event.keyCode == '40' || event.keyCode == '39') {
    event.preventDefault();
    var tabTarget = focusToTabItem(event.target, 'next');
    tabTarget.focus(); 
  }

  // Mega Menus
  if (activator.classList.contains('mega-menu--btn')) {
    // focus on first link in panel on down arrow or enter key press
    if (event.keyCode == '40' || event.keyCode == '13') {
      event.preventDefault();
      const mmID = 'megaPanel' + menuIndex;
      const mm = document.getElementById(mmID);
      const selector = '#' + mmID + ' .megamenuItem, ' + '#' + mmID + ' .mega-menu--sublink';
      const items = document.querySelectorAll(selector);
      const lastItem = items[items.length - 1];

      // focus on first item in mega menu
      items[0].focus();

      // arrow key navigation within mega menus
      for (var i = 0; i < items.length; i++) {
        items[i].addEventListener('keydown', function(evt) {
          // down & right arrow keys
          if (evt.keyCode == '40' || evt.keyCode == '39') {
            evt.preventDefault();
            var tabTarget = focusToTabItem(evt.target, 'next');
            tabTarget.focus();
          // up and left arrow keys
          } else if (evt.keyCode == '38' || evt.keyCode == '37') {
            // go back to activating button if first item in mega menu
            if (evt.target === items[0]) {
              activator.focus();
            // behavior for all other items
            } else {
              evt.preventDefault();
              var tabTarget = focusToTabItem(evt.target, 'prev');
              tabTarget.focus();
            }
          }
        })
      }

      // tab to next top-level nav item if on last link in panel
      lastItem.addEventListener('keydown', function(e) {
        e.preventDefault();
        if (e.keyCode == '9' || e.keyCode == '40' || e.keyCode == '39') {
          activator.focus();
          if (typeof activator.parentNode.nextElementSibling.children[0] !== 'undefined') {
            activator.parentNode.nextElementSibling.children[0].focus();
          } else {
            activator.parentNode.nextElementSibling.focus();
          }
        }
      })
    }
  }
}

// gets next or previous element in page's tab order
function focusToTabItem(element, dir) {
  var focusableElements = document.querySelectorAll('.header-logo, .desktop-search, button, select, textarea, a');
  var list = Array.prototype.filter.call(focusableElements, function(item) {
    return item.tabIndex >= "0";
  });
  var index = list.indexOf(element);
  if (dir === 'next') {
    return list[index + 1] || list[0];
  } else if (dir === 'prev') {
    return list[index - 1] || list[0];
  }
}